import { render, staticRenderFns } from "./AddNotes.vue?vue&type=template&id=6034e0ad"
import script from "./AddNotes.vue?vue&type=script&lang=js"
export * from "./AddNotes.vue?vue&type=script&lang=js"
import style0 from "./AddNotes.vue?vue&type=style&index=0&id=6034e0ad&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports